export default "__VITE_ASSET__5IlUrCfZ__"